import { useMutation, useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { FaCheck, FaPlus, FaTimes } from "react-icons/fa";
import { FcCheckmark } from "react-icons/fc";
import styled from "styled-components";
import { OutsideClick } from "../../Components";

import AvatarComponent from "./Components/AvatarComponent";
import Column from "./Components/Column";
import DeleteModal from "./Components/DeleteModal";
import EditTask from "./Components/EditTask";
import "./Components/scroll.scss";
import {
  ADD_COLUMN_TO_BOARD,
  DeleteTaskCard,
  EDIT_TASK_MANAGEMENT_BOARD_SERIAL_NO,
  Edit_Task_Position,
  GET_ALL_TASKS,
  GET_BOARD_BY_ID,
  users_query,
} from "./utils/quires";
import { SuccessToast, WarningToast } from "../../Components/ToastComponent/RectHotToast";

function KanbanBoard({ id, SetBoardName }) {
  const [boardData, setBoardData] = useState(null);
  const [tasks, setTasks] = useState(null);
  const [OpenDeleteModel, setOpenDeleteModel] = useState(false);
  const [BoardId, setBoardId] = useState(null);
  const [ColumnID, setColumnID] = useState("");
  const [isAddingColumn, setIsAddingColumn] = useState(false);
  const [newColumnName, setNewColumnName] = useState("");
  const [SearchValue, setSearchValue] = useState("");

  // this varbale related selected user assigne
  const [users, setUsers] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedUserIds, setSelcteduseids] = useState([]);
  const visibleUsers = users.slice(0, 5);
  const hiddenUsers = users.slice(5);
  //
  const [currentEditingTaskId, setCurrentEditingTaskId] = useState(null);
  const { data: boardDataQuery, loading: LoaderBoard } = useQuery(GET_BOARD_BY_ID, { variables: { id } });
  const {
    data: tasksQuery,
    refetch: refetchTasks,
    loading: LoadGetTasks,
  } = useQuery(GET_ALL_TASKS, {
    variables: {
      userInput: {
        Board_ID: id,
        User: [],
        keyword: "",
      },
    },
  });

  const [editSerialNo, { loading: EditRowLoading }] = useMutation(EDIT_TASK_MANAGEMENT_BOARD_SERIAL_NO, {
    refetchQueries: [
      {
        query: GET_ALL_TASKS,
        variables: {
          userInput: {
            Board_ID: id,
            User: [],
            keyword: "",
          },
        },
      },
    ],
  });
  const [addColumn, { loading: AddLoading }] = useMutation(ADD_COLUMN_TO_BOARD, {
    refetchQueries: [{ query: GET_BOARD_BY_ID, variables: { id: BoardId } }],
  });
  const [EditTaskPosition, { loading: editTaskLoading }] = useMutation(Edit_Task_Position, {
    refetchQueries: [
      {
        query: GET_ALL_TASKS,
        variables: {
          userInput: {
            Board_ID: id,
            User: [],
            keyword: "",
          },
        },
      },
    ],
    onCompleted: () => {
      // SuccessToast("Task Position Changed Sucessfuly!");
    },
  });
  //
  const [DeleteTaskFormBoard] = useMutation(DeleteTaskCard, {
    refetchQueries: [
      {
        query: GET_ALL_TASKS,
        variables: {
          userInput: {
            Board_ID: id,
            User: [],
            keyword: "",
          },
        },
      },
    ],
    onError: (res) => {
      WarningToast(res.message);
    },
    onCompleted: (res) => {
      SuccessToast(res?.DeleteTaskCard?.message);
    },
  });
  const { data: userdetails, loading: usersLoad } = useQuery(users_query);

  const Loader = LoaderBoard || LoadGetTasks || AddLoading || editTaskLoading || usersLoad || EditRowLoading;
  const handleSelectedIds = (selectedID) => {
    if (selectedUserIds.includes(selectedID)) {
      const Data = selectedUserIds.filter((item) => item !== selectedID);
      setSelcteduseids(Data);
    } else {
      setSelcteduseids([...selectedUserIds, selectedID]);
    }
  };
  const handleDropdownToggle = () => {
    setShowDropdown(!showDropdown);
  };
  //

  useEffect(() => {
    // if (selectedUserIds.length > 0 || SearchValue.length > 0) {
    const handler = setTimeout(() => {
      // Refetch the tasks with a delay of 1 second only when selectedUserIds.length is more than zero

      const userInput = {
        Board_ID: id,
        User: selectedUserIds,
        keyword: SearchValue,
      };
      refetchTasks({
        userInput,
      });
    }, 1000); // Delay of 1 second

    return () => clearTimeout(handler); // Clear the timeout if the component unmounts or the selectedUserIds changes again before the timeout completes
    // }
  }, [selectedUserIds, refetchTasks, id, SearchValue]); // Include all dependencies here

  useEffect(() => {
    if (boardDataQuery?.TaskManagementBoardByID) {
      const { _id, Columns, Board_Name } = boardDataQuery.TaskManagementBoardByID;
      console.log(boardDataQuery.TaskManagementBoardByID, "boardDataQuery");
      setBoardData(Columns);
      setBoardId(_id);
      SetBoardName(Board_Name);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [boardDataQuery]);

  useEffect(() => {
    if (tasksQuery?.GetAllTaskManagementTasks && boardData) {
      const tasksNormalized = tasksQuery.GetAllTaskManagementTasks.reduce((acc, taskGroup) => {
        acc[taskGroup._id] = taskGroup.tasks;
        return acc;
      }, {});

      // Ensure every column has an entry, even if it's an empty array
      boardData.forEach((column) => {
        if (!tasksNormalized.hasOwnProperty(column._id)) {
          tasksNormalized[column._id] = [];
        }
      });

      setTasks(tasksNormalized);
    }
  }, [tasksQuery, boardData]); // Depend on boardData as well

  useEffect(() => {
    if (userdetails?.getallusers) {
      const data = userdetails?.getallusers;
      setUsers(data);
    }
  }, [userdetails]);
  useEffect(() => {
    if (selectedUserIds.length > 0) {
      // Sort users based on whether they are selected
      const sortedUsers = [...users].sort((a, b) => {
        const aSelected = selectedUserIds.includes(a._id);
        const bSelected = selectedUserIds.includes(b._id);
        if (aSelected && !bSelected) return -1;
        if (!aSelected && bSelected) return 1;
        return 0;
      });
      setUsers(sortedUsers);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedUserIds]);

  const handleEditTask = (taskId) => {
    // This function toggles the task to edit or closes the sidebar if the same task is clicked again
    if (currentEditingTaskId === taskId) {
      setCurrentEditingTaskId(null); // Close the sidebar
    } else {
      setCurrentEditingTaskId(taskId); // Open/Edit another task
    }
  };
  const onDragEnd = (result) => {
    const { destination, source, type } = result;
    if (!destination || (destination.droppableId === source.droppableId && destination.index === source.index)) {
      return;
    }

    if (type === "column") {
      const newColumnOrder = Array.from(boardData);
      const [movedColumn] = newColumnOrder.splice(source.index, 1);
      newColumnOrder.splice(destination.index, 0, movedColumn);

      const serialUpdates = newColumnOrder.map((column, index) => ({ _id: column._id, Serial_No: index }));
      editSerialNo({
        variables: {
          editTaskManagementBoardId: id,
          userInput: serialUpdates,
        },
      });
      setBoardData(newColumnOrder);
    } else {
      const start = tasks[source.droppableId];
      const finish = tasks[destination.droppableId];

      if (start === finish) {
        const newTaskIds = Array.from(start);
        const [movedTask] = newTaskIds.splice(source.index, 1);
        newTaskIds.splice(destination.index, 0, movedTask);

        // Update the Serial_No for each task and store the result
        let final_index = 0;
        const previse_data = newTaskIds.find((ele, index) => index === destination.index - 1);
        const next_data = newTaskIds.find((ele, index) => index === destination.index + 1);
        if (previse_data === undefined) {
          let ind = next_data?.Serial_No ?? 0;
          final_index = ind - 1;
        } else if (next_data === undefined) {
          final_index = previse_data?.Serial_No + 1;
        } else {
          final_index = (previse_data?.Serial_No + next_data?.Serial_No) / 2;
        }
        newTaskIds.map((ele, index) => ({
          _id: ele._id,
          Serial_No: index,
          Column_ID: ele?.Column_ID,
        }));

        EditTaskPosition({
          variables: {
            id: movedTask._id,
            userInput: {
              Serial_No: final_index,
              // Column_ID: movedTask.Column_ID,
            },
          },
        });

        const newTasks = { ...tasks, [source.droppableId]: newTaskIds };
        setTasks(newTasks);
      } else {
        const startTaskIds = Array.from(start);
        const [movedTask] = startTaskIds.splice(source.index, 1);
        const finishTaskIds = Array.from(finish);
        finishTaskIds.splice(destination.index, 0, movedTask);

        let final_index = 0;
        const previse_data = finishTaskIds.find((ele, index) => index === destination.index - 1);
        const next_data = finishTaskIds.find((ele, index) => index === destination.index + 1);
        const finalindex = previse_data?.Serial_No || 0 + next_data?.Serial_No || 0;

        if (previse_data === undefined) {
          final_index = -1;
        } else if (next_data === undefined) {
          final_index = previse_data?.Serial_No + 1;
        } else {
          final_index = (previse_data?.Serial_No + next_data?.Serial_No) / 2;
        }

        finishTaskIds.map((ele, index) => ({
          _id: ele._id,
          Serial_No: finalindex / 2,
          Column_ID: destination.droppableId,
        }));

        EditTaskPosition({
          variables: {
            id: movedTask._id,
            userInput: {
              Serial_No: final_index,
              Column_ID: destination.droppableId,
            },
          },
        });
        const newTasks = {
          ...tasks,
          [source.droppableId]: startTaskIds,
          [destination.droppableId]: finishTaskIds,
        };
        setTasks(newTasks);
      }
    }
  };
  const handleCloseNewColumn = () => {
    setIsAddingColumn(false);
    setNewColumnName("");
  };
  const haandleOpenDeleteColumn = (columnID) => {
    setColumnID(columnID);
    setOpenDeleteModel(!OpenDeleteModel);
  };
  const handleCloseDeleteColumn = () => {
    setOpenDeleteModel(!OpenDeleteModel);
  };
  const handleOpenNewColumn = () => setIsAddingColumn(true);
  const handleNewColumnNameChange = (e) => setNewColumnName(e.target.value);
  const handleAddNewColumn = () => {
    const newColumn = {
      Title: newColumnName,
      Serial_No: boardData?.length || 0,
    };
    addColumn({
      variables: {
        addColumntoBoardId: BoardId,
        userInput: newColumn,
      },
    });
    setNewColumnName("");
    setIsAddingColumn(false);
  };

  return (
    <>
      {Loader && <div className="loader-line-div"></div>}
      <SearchContainer>
        <LeftContainer>
          <TitleEditInput
            className="search-input"
            value={SearchValue}
            placeholder="Search board"
            type="search"
            onChange={(e) => setSearchValue(e.target.value)}
          />
          <div className="avatar-container">
            <div className="avatar-stack">
              {visibleUsers?.map((user, index) => (
                <AvatarComponent
                  key={index}
                  imgSrc={"path_to_image_1.jpg"}
                  fullName={user.Full_Name}
                  handleselectedIds={handleSelectedIds}
                  id={user._id}
                  selectedUserIds={selectedUserIds}
                />
              ))}
              {hiddenUsers.length > 0 && (
                <div className="more-avatars" onClick={handleDropdownToggle}>
                  +{hiddenUsers.length}
                </div>
              )}
            </div>
            {showDropdown && (
              <OutsideClick setToggled={setShowDropdown}>
                <OptionsMenu show={showDropdown} className="options-menu">
                  {hiddenUsers?.map((ele) => {
                    const className = selectedUserIds.includes(ele._id) ? "check-clikced" : "hide-checkbox";
                    return (
                      <OptionItem onClick={() => handleSelectedIds(ele._id)}>
                        <span className={className}>
                          <FcCheckmark />
                        </span>
                        <AvatarComponent
                          fullName={ele?.Full_Name}
                          imgSrc={"path_to_image_1.jpg"}
                          clickble={false}
                          hover={false}
                        />{" "}
                        {ele?.Full_Name}
                      </OptionItem>
                    );
                  })}
                </OptionsMenu>
              </OutsideClick>
            )}
          </div>
        </LeftContainer>
        <RightContainer></RightContainer>
      </SearchContainer>
      <BoardContainer>
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="all-columns" direction="horizontal" type="column">
            {(provided) => (
              <div
                {...provided.droppableProps}
                ref={provided.innerRef}
                style={{
                  display: "flex",
                  justifyContent: "start",
                  height: "100%",
                }}
              >
                {boardData?.map((columnId, index) => {
                  const isColumnCollapsed = columnId?.Is_Collapsed;
                  const taskColumn = columnId?._id;

                  return (
                    <Draggable key={columnId?._id} draggableId={columnId?._id} index={index}>
                      {(provided, snapshot) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          style={{
                            userSelect: "none",
                            padding: "2px",
                            margin: "0 8px",
                            minWidth: isColumnCollapsed ? "150px" : "250px", // Collapse width
                            background: isColumnCollapsed ? "transparent" : "#ebecf0", // Transparent when collapsed
                            display: "flex",
                            flexDirection: "column",
                            borderRadius: "5px",
                            [snapshot.isDragging ? "rotate" : "trasform"]: snapshot.isDragging ? "10deg" : null,
                            ...provided.draggableProps.style,
                          }}
                        >
                          <Column
                            column={columnId}
                            tasks={tasks?.[taskColumn] || []}
                            isCollapsed={isColumnCollapsed}
                            BoardId={id}
                            haandleOpenDeleteColumn={haandleOpenDeleteColumn}
                            handleEditTask={handleEditTask}
                          />
                        </div>
                      )}
                    </Draggable>
                  );
                })}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
        {/* New Column Creation UI */}
        {isAddingColumn ? (
          <HeaderInputBox>
            <TitleEditInput
              placeholder="Enter column name..."
              value={newColumnName}
              onChange={handleNewColumnNameChange}
              autoFocus
            />
            <EditButtons>
              <IconButton onClick={handleAddNewColumn}>
                <FaCheck size={14} />
              </IconButton>
              <IconButton onClick={handleCloseNewColumn}>
                <FaTimes size={14} />
              </IconButton>
            </EditButtons>
          </HeaderInputBox>
        ) : (
          <IconButton onClick={handleOpenNewColumn} style={{ marginTop: "6px" }}>
            <FaPlus size={20} />
          </IconButton>
        )}
        {OpenDeleteModel && (
          <DeleteModal
            open={OpenDeleteModel}
            ColumnData={boardData}
            ColumnID={ColumnID}
            onClose={handleCloseDeleteColumn}
            BoardID={BoardId}
            tasks={tasks}
          />
        )}
      </BoardContainer>
      {/* Conditionally render EditTask based on currentEditingTaskId */}
      {currentEditingTaskId && (
        <EditTask
          open={true}
          TaskId={currentEditingTaskId}
          handleEditTask={handleEditTask}
          DeleteTask={DeleteTaskFormBoard}
        />
      )}
    </>
  );
}

export default KanbanBoard;
// Styled components for New Column Form
const HeaderInputBox = styled.div`
  display: flex;
  flex-direction: column;
`;

const TitleEditInput = styled.input`
  font-size: 1rem;
  font-weight: bold;
  padding: 8px;
  border: 1px solid #dfe1e6;
  border-radius: 3px;
  width: calc(100% - 16px); /* Account for padding */
  box-sizing: border-box;
  &:focus {
    outline: none;
    border: 2px solid #388bff;
    box-shadow: none;
  }
`;
const IconButton = styled.button`
  border: none;
  color: #42526e;
  background: #ffffff;
  border-radius: 3px;
  height: 30px;
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-left: 4px; // Space between buttons
  box-shadow: 0 2px 0 rgba(9, 30, 66, 0.25);

  &:hover {
    background-color: #ebecf0;
  }

  &:active {
    background-color: #dfe1e6;
  }
`;

const EditButtons = styled.div`
  display: flex;
  align-items: center;
  margin-left: 150px; // Space from input box
`;
const BoardContainer = styled.div`
  display: flex;
  overflow-x: auto;
  height: 100%; // Ensure this matches your layout requirements
`;

const SearchContainer = styled.div`
  /* height:2rem;
  width:100%; */
  height: 2rem;
  padding: 15px 10px;
  display: flex;
  flex-direction: row;
  /* border: 2px solid gray; */
  overflow: visible;
`;

const LeftContainer = styled.div`
  width: 50%;
  display: flex;
  flex-direction: row;
  .search-input {
    width: 15rem;
    font-weight: 400;
    /* border: 2px solid #8590a2; */
  }
  .avatar-stack {
    display: flex;
    align-items: center;
    margin-left: 15px;
    .avatar-container {
      margin-left: -10px; // Adjust overlap

      &:first-child {
        margin-left: 0;
        z-index: 8;
      }
      &:nth-child(2) {
        z-index: 7;
      }
      &:nth-child(3) {
        z-index: 6;
      }
      &:nth-child(4) {
        z-index: 5;
      }
      &:hover {
        z-index: 10; // Bring to front on hover
      }
      .more-avatars {
        width: 35px;
        height: 35px;
        border-radius: 50%;
        background-color: #e0e0e0;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #555;
        font-size: 14px;
        cursor: pointer;
        border: 2px solid #fff;
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
      }
    }
  }
  .more-avatars {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    border: 2px solid #fff;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
    background-color: #f1f2f4;
    color: #626f86;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    margin-left: -10px;
  }
`;
const RightContainer = styled.div``;

const OptionsMenu = styled.div`
  display: ${(props) => (props.show ? "block" : "none")};
  max-height: 250px;
  overflow: auto;
  position: absolute;
  top: 43px;
  right: -150px;

  background-color: #ffffff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  z-index: 100;
`;

const OptionItem = styled.div`
  padding: 5px 8px;

  .avatar-fallback {
    width: 25px;
    height: 25px;
    font-size: 13px;
  }
  .check-clikced {
    width: 20px;
    margin-right: 5px;
  }
  .hide-checkbox {
    width: 20px;
    margin-right: 5px;
    visibility: hidden;
  }
  &:hover {
    background-color: #f0f0f0;
    cursor: pointer;
  }
`;
